import { Router, NavigationExtras } from '@angular/router';
import { Injectable } from '@angular/core';
import { ItemObject } from 'src/app/models/products/item/item-object.model';
import { TabObject } from 'src/app/models/products/item/tab-object.model';
import { isNull } from 'util';
import { ProductTypeObject } from 'src/app/models/products/product-type-object.model';

@Injectable({
    providedIn: 'root'
})
export class ProductsRouterService {

    constructor(private router: Router) { }

    public navigate(item: ItemObject) {

        const navigationExtras: NavigationExtras = {
            queryParams: {
                id: item.productId,
                map: item.map,
                type: item.type.urlPath,
                tab: item.tab.name
            }
        };
        if (!item.type.equals(ProductTypeObject.UNKNOWN)) {
            this.router.navigate([item.url], navigationExtras);
        };
    }

}
